import React from "react";

import loading from "../static/app/gif/loading.gif";

export default class Loading extends React.Component {
  render() {
    return (
      <div
        id="loading"
        style={{
          display: "flex",
          zIndex: "99999",
          position: "fixed",
          top: "0px",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          opacity: "0.9",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={loading} alt="Loading" />
      </div>
    );
  }
}
